import React, {Component} from 'react'
import { connect } from 'react-redux'

var saleCommonUtility = require('../../../../utils/domain/sales/saleCommonUtility.js');
var saleCalculator = require('../../../../utils/domain/sales/saleCalculator.js');
var constants = require('../../../../utils/domain/constants.js');
var localizationUtils = require('../../../../utils/domain/localizationUtils.js');
var formatter = require('../../../../utils/formatter/formatter.js');

const foreColorColor = '#F0F0F0';
const translator = require('../../../../utils/translator/translator.js');

class Summary extends Component 
{
    render()
    {
        let sale = this.props.saleContext.sale;

        var totalPrice = saleCalculator.calculateTotalOrderPrice(sale);
        var totalDiscount = saleCalculator.calculateTotalDiscounts(sale);
        var totalCharges = saleCalculator.calculateTotalCharges(sale);
        var totalNetSale = saleCalculator.calculateTotalNetSalePrice(sale);
        var totalRemaining = saleCalculator.calculateRemainingPayableAmount(sale);

        let backGroundColor = 'var(--bs-gray-800)';
        if (saleCommonUtility.isSaleHoldByStaff(sale))
            backGroundColor = '#C41E3A';

        var vatWidget = null;
        if (!localizationUtils.isVatInclusive() && localizationUtils.isVatApplicable())
        {
            let totalVat = saleCalculator.calculateTotalVAT(sale)
;           vatWidget = <tr>
                            <td width="99%" >
                                <div style={{marginLeft: '5px', color: "#ffffffd0"}}>{translator.getLabel("total")} {localizationUtils.getVatCaption()}</div>
                            </td>
                            <td style={{whiteSpace: "nowrap", textAlign:'right'}}>
                                <div style={{marginRight: '5px'}}>{formatter.convertToCurrencyFormat(totalVat)}</div>
                            </td>
                        </tr>
        }

        var components = [];
        components.push(<div style={{padding:'5px', background:backGroundColor, color:foreColorColor, border:`1px solid ${backGroundColor}`, borderRadius:5}}>  
                            <table style={{width:'100%'}}>
                                <tr>
                                    <td width="99%" >
                                        <div style={{marginLeft: '5px', color: "#ffffffd0"}}>{translator.getLabel("total_order_price")}</div>
                                    </td>
                                    <td style={{whiteSpace: "nowrap", textAlign:'right'}}>
                                        <div style={{marginRight: '5px'}}>{formatter.convertToCurrencyFormat(totalPrice)}</div>
                                    </td>
                                </tr>
                                {
                                    totalDiscount <= constants.numericThresholdValue 
                                        ? null 
                                        : <tr>
                                            <td width="99%" >
                                                <div style={{marginLeft: '5px', color: "#ffffffd0"}}>{translator.getLabel("total_discount")}</div> 
                                            </td>
                                            <td style={{whiteSpace: "nowrap", textAlign:'right'}}>
                                                <div style={{marginRight: '5px'}}>{formatter.convertToCurrencyFormat(totalDiscount)}</div>
                                            </td>
                                        </tr>
                                }

                                {
                                    totalCharges <= constants.numericThresholdValue
                                        ? null
                                        : <tr>
                                            <td width="99%" >
                                                <div style={{marginLeft: '5px', color: "#ffffffd0"}}>{translator.getLabel("total_charges")}</div> 
                                            </td>
                                            <td style={{whiteSpace: "nowrap", textAlign:'right'}}>
                                                <div style={{marginRight: '5px'}}>{formatter.convertToCurrencyFormat(totalCharges)}</div>
                                            </td>
                                        </tr>
                                }
                                
                                {vatWidget}
                                <tr>
                                    <td width="99%" >
                                        <div style={{marginLeft: '5px', color: "#ffffffd0"}}>{translator.getLabel("total_sale_price")}</div> 
                                    </td>
                                    <td style={{whiteSpace: "nowrap", textAlign:'right'}}>
                                        <div style={{marginRight: '5px'}}>{formatter.convertToCurrencyFormat(totalNetSale)}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="99%" >
                                    <div style={{marginLeft: '5px', marginTop:'4px'}}>{translator.getLabel("total_payable")}</div> 
                                    </td>
                                    <td style={{whiteSpace: "nowrap", textAlign:'right'}}>
                                        <div style={{marginRight: '5px', marginTop:'4px', fontSize: "1.3rem"}}>{formatter.convertToCurrencyFormat(totalRemaining)}</div>
                                    </td>
                                </tr>
                            </table>
                        </div>)

        return components;
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(Summary)